import * as io from 'io-ts';

export const MoneyValue = io.Int;

export type MoneyValue = io.TypeOf<typeof MoneyValue>;

export const Money = io.type({
  currency: io.string,
  value: MoneyValue,
});

export type Money = io.TypeOf<typeof Money>;
